import React from "react"
import { Link } from "react-router-dom"
export const incidentLabels = { NO_SHOW: "No show", ABANDONED: "Abandoned" }
export default function IncidentContext({ evidence, eventId, competitionId }) {
  if (!evidence) return null
  return <div className="penalty-incident-context">
    <div><strong>{incidentLabels[evidence.kind] || "Recorded incident"}</strong> · <Link to={`/events/${eventId}/competitions/${competitionId}/matches`}>{evidence.matchNumber ? `Match #${evidence.matchNumber}` : "Main Draw match"}</Link>{evidence.group != null && ` · Group ${evidence.group}`}{evidence.stage != null && ` · Round ${evidence.stage}`}</div>
    <div>{evidence.team?.map(p => p.name).join(" / ") || "Team unavailable"} <span className="text-muted">vs</span> {evidence.opponents?.map(p => p.name).join(" / ") || "Opponent unavailable"}</div>
    {evidence.gameType === "doubles" && <small className="text-muted">Team outcome. Responsibility is reviewed individually for each partner.</small>}
  </div>
}
